<template>
  <header
    class="fixed left-0 top-0 w-full z-50 transition-all rounded-b-lg"
    :class="isScroll && 'bg-white shadow'"
  >
    <div class="mx-auto px-6 py-6 lg:max-w-7xl">
      <nav class="flex items-center justify-between" aria-label="Global">
        <div class="flex items-center gap-2">
          <router-link
            to="/"
            class="-m-1.5 p-1.5 text-xl font-black group inline-flex italic"
          >
            <span class="sr-only">Juniper Education</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Layer_1"
              x="0px"
              y="0px"
              viewBox="0 0 1200 345"
              xml:space="preserve"
              width="120"
              height="30"
              class="jui-omnibar__svg"
            >
              <g>
                <g>
                  <g>
                    <path
                      class="st0"
                      d="M115.9,32.7v145.5c0,21.6-13.7,38.4-35.7,38.4c-20.3,0-34.4-13.7-38.4-32.2l-38.8,4     c4,39.7,37.5,70.5,78.5,70.5c54.7,0,80.2-38.4,80.2-93.9V32.7H115.9z"
                    ></path>
                    <path
                      class="st0"
                      d="M317.8,84.3v121.3c-10.1,8.4-22.9,13.7-38.8,13.7c-24.7,0-37.5-13.2-37.5-39.7V84.3h-44.1v95.2     c0,56,23.4,79.4,73.7,79.4c17.6,0,33.9-5.3,46.7-14.1v11.5h44.1v-172H317.8z"
                    ></path>
                    <path
                      class="st0"
                      d="M489.8,80.7c-17.2,0-33.1,5.3-45.8,14.1V84.3h-44.1v172h44.1V134.1c9.7-8.8,22.5-13.7,37.9-13.7     c24.7,0,37.5,13.2,37.5,39.7v96.1h44.1v-96.1C563.4,104.5,540,81.2,489.8,80.7z"
                    ></path>
                  </g>
                  <rect
                    x="600.4"
                    y="84.3"
                    class="st0"
                    width="44.1"
                    height="172"
                  ></rect>
                  <g>
                    <path
                      class="st0"
                      d="M1058.5,172.9c0-53.3-30.9-91.7-83.8-91.7c-52,0-88.2,39.7-88.2,89.1c0,48.9,36.1,88.6,88.2,88.6     c33.5,0,61.7-14.1,77.6-35.3l-28.2-23.4c-9.7,12.8-26.4,21.2-44.5,21.2c-26.5,0-44.6-15.9-49-38.4h127.4     C1058.1,179.9,1058.5,176.4,1058.5,172.9z M931.1,154.4c3.9-21.2,20.7-38.4,43.6-38.4c29.5,0,40.1,18.5,41.4,38.4H931.1z"
                    ></path>
                    <path
                      class="st0"
                      d="M1186.4,80.7c-24.3,0.4-42.3,11-54.2,27.3V83.4h-44.1v172h44.1v-82.9c0-22.5,11.9-45,43.7-45     c9.3,0,21.2,2.6,21.2,2.6V82.5C1193.9,81.2,1189.5,80.7,1186.4,80.7z"
                    ></path>
                    <path
                      class="st0"
                      d="M777.7,81.2c-18.1,0-35.7,4.9-49.8,13.2V84.3h-44.1v227.5h44.1v-66.1c14.1,8.4,31.7,12.8,49.8,12.8     c47.6,0,87.3-35.7,87.3-88.6C864.5,116,825.3,81.2,777.7,81.2z M769.8,219.2c-16.8,0-31.7-5.3-42.3-14.5v-69.2     c10.6-9.3,25.6-15,42.3-15c29.5,0,51.6,21.2,51.6,49.4C821.3,199.3,799.3,219.2,769.8,219.2z"
                    ></path>
                    <path
                      class="st1"
                      d="M598.2,25.2c0-6.6,2.2-12.3,7.1-17.2c4.8-4.8,10.6-7.1,17.2-7.1c6.6,0,12.3,2.2,17.2,7.1     c4.9,4.9,7.1,10.6,7.1,17.2c0,6.6-2.2,12.3-7.1,17.2c-4.9,4.9-10.6,7.1-17.2,7.1c-6.6,0-12.4-2.2-17.2-7.1     C600.4,37.5,598.2,31.8,598.2,25.2"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      class="st1"
                      d="M798.6,337.1v6.5h-45.2v-62.4h43.3v6.5h-36v22.5h30.5v6.4h-30.5v20.6H798.6z"
                    ></path>
                    <path
                      class="st1"
                      d="M854.7,276.8v66.8h-7.3v-4.6c-4.3,3.2-10.4,5.1-16.6,5.1c-13.6,0-24.7-10.5-24.7-24.6     c0-14.3,11.2-24.7,24.7-24.7c6.5,0,12.2,1.9,16.6,5v-23H854.7z M847.4,331.8v-24.9c-3.7-3.5-9.2-5.6-15.6-5.6     c-10.3,0-18.4,8-18.4,18.2c0,10.3,8.1,18.1,18.4,18.1C838.1,337.5,843.6,335.4,847.4,331.8z"
                    ></path>
                    <path
                      class="st1"
                      d="M911.8,295.6v47.9h-7.4v-5c-4.2,3.5-10.1,5.5-16.6,5.5c-12.8,0-20.5-6.9-20.5-21.6v-26.8h7.3v26.8     c0,9.9,5.9,15.1,14.4,15.1c6.4,0,11.4-1.9,15.4-5.4v-36.5H911.8z"
                    ></path>
                    <path
                      class="st1"
                      d="M966.5,335.2c-4.3,5.5-10.8,8.9-17.9,8.9c-14.4,0-26.1-11.1-26.1-24.6c0-13.6,11.7-24.7,26.1-24.7     c7.4,0,13.7,3.4,18,8.7l-4.9,4.4c-3.1-4-7.8-6.6-13.1-6.6c-10.5,0-18.9,8.1-18.9,18.2c0,9.9,8.4,18.1,18.9,18.1     c5.2,0,10-2.7,13.1-6.7L966.5,335.2z"
                    ></path>
                    <path
                      class="st1"
                      d="M1022.7,295.6v47.9h-7.4v-4.8c-4.3,3.3-10,5.3-16.7,5.3c-14.4,0-24.4-11.5-24.4-24.7     c0-13.1,9.9-24.6,24.4-24.6c6.3,0,12.4,2,16.7,5.3v-4.4H1022.7z M1015.3,307.1c-3.8-3.6-9.2-5.8-15.5-5.8     c-10.6,0-18.4,8.2-18.4,18.1c0,9.8,7.9,18.2,18.4,18.2c6.4,0,11.8-2.1,15.5-5.6V307.1z"
                    ></path>
                    <path
                      class="st1"
                      d="M1046.3,301.7v24.1c0,8.9,3,11.9,9.2,11.9c3.1,0,5.2-0.4,6.8-0.6v5.6c-1.2,0.4-4.3,1.4-9.7,1.4     c-7.6,0-13.8-4.9-13.8-14.4v-27.9h-7.9v-6.1h7.9v-18.9h7.4v18.9h16.2v6.1H1046.3z"
                    ></path>
                    <path
                      class="st1"
                      d="M1070.5,283.1c0-2.6,2.1-4.5,4.7-4.5c2.5,0,4.5,1.9,4.5,4.5c0,2.6-2,4.6-4.5,4.6     C1072.7,287.7,1070.5,285.6,1070.5,283.1z M1071.5,295.6h7.4v47.9h-7.4V295.6z"
                    ></path>
                    <path
                      class="st1"
                      d="M1141.8,319.5c0,13.6-11.7,24.6-26,24.6c-14.4,0-26.1-11.1-26.1-24.6c0-13.6,11.7-24.7,26.1-24.7     C1130.1,294.7,1141.8,305.8,1141.8,319.5z M1134.6,319.5c0-10-8.4-18.2-18.8-18.2c-10.5,0-18.9,8.1-18.9,18.2     c0,9.9,8.4,18.1,18.9,18.1C1126.2,337.5,1134.6,329.4,1134.6,319.5z"
                    ></path>
                    <path
                      class="st1"
                      d="M1196.5,316.4v27.2h-7.3v-27.2c0-9.9-5.8-15.1-14.4-15.1c-6.3,0-11.1,2-14.9,5.4v36.8h-7.4v-47.9h7.4v4.6     c4-3.5,9.7-5.5,16-5.5C1188.7,294.7,1196.5,301.7,1196.5,316.4z"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          </router-link>

          <div class="hidden ml-12 md:flex gap-x-14">
            <router-link
              v-for="item in navigation.links"
              :key="item.id"
              :to="item.href"
              class="nav-link text-sm/6 font-semibold relative hover:text-purple-800"
              active-class="text-purple-600"
              >{{ item.label }}
            </router-link>
          </div>
        </div>
        <div class="md:hidden">
          <Popper placement="bottom-end">
            <button
              aria-label="Open Navigation links"
              class="relative h-6 w-6 cursor-pointer p-1"
            >
              <span
                class="absolute left-0 top-1 h-0.5 w-full bg-gray-800 rounded"
              ></span>
              <span
                class="absolute left-0 top-3 h-0.5 w-full bg-gray-800 rounded"
              ></span>
              <span
                class="absolute left-0 top-5 h-0.5 w-full bg-gray-800 rounded"
              ></span>
            </button>

            <template #content="{ close }">
              <div
                class="px-2 py-2 border border-gray-200 rounded-lg shadow-sm bg-white"
              >
                <ul>
                  <li v-for="item in navigation.links" :key="item.id">
                    <div
                      class="text-sm/6 font-semibold text-gray-600 min-w-32 flex justify-between items-center gap-8 px-1.5 py-1 rounded"
                    >
                      <router-link
                        :to="item.href"
                        @click="close"
                        class="hover:text-gray-800 hover:bg-gray-100"
                      >
                        {{ item.label }}
                      </router-link>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
          </Popper>
        </div>
      </nav>
    </div>
  </header>
</template>
<script setup lang="ts">
import { ref, onMounted } from "vue";
import Popper from "vue3-popper";
const navigation = {
  links: [
    { id: "teachers", label: "For Teachers", href: "/teacher" },
    { id: "parent", label: "For Parents", href: "/parent" },
  ],
  cta: [
    {
      id: "1",
      label: "Download Juniper App",
    },
  ],
};

const isScroll = ref(false);

onMounted(() => {
  window.addEventListener("scroll", () => {
    window.scrollY > 100 ? (isScroll.value = true) : (isScroll.value = false);
  });
});
</script>

<style scoped>
.st0 {
  fill: #271a38;
}

.st1 {
  fill: #814af4;
}

.nav-link::before {
  opacity: 0;
  transition: all 0.3s;
  content: "";
  position: absolute;
  bottom: -6px;
  width: 100%;
  height: 8px;
  background-image: url("/graphics/green/underline-1.svg");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.nav-link.router-link-exact-active::before {
  opacity: 1;
}
</style>
